import React from "react";

const ModalWrapper = ({ open, title, children, onClose, size = "modal-lg" }) => {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

const renderCentroOptions = (centros = [], loading) => {
  if (loading) {
    return (
      <option value="" disabled>
        Cargando centros...
      </option>
    );
  }
  if (!centros.length) {
    return (
      <option value="" disabled>
        Sin centros disponibles
      </option>
    );
  }
  return centros.map((centro) => (
    <option key={centro.id} value={String(centro.id)}>
      {centro.alias || centro.nombre}
    </option>
  ));
};

const toggleCurso = (form, setForm, cursoId) => {
  const id = Number(cursoId);
  const current = Array.isArray(form.curso_ids) ? form.curso_ids : [];
  const next = current.includes(id) ? current.filter((c) => c !== id) : [...current, id];
  setForm((prev) => ({ ...prev, curso_ids: next }));
};

const FormFields = ({
  form,
  setForm,
  estadoOptions,
  centros,
  reloadCursos,
  centrosLoading,
  centrosError,
  reloadCentros,
  plantillas,
  loadingPlantillas,
  cursos,
  loadingCursos,
}) => {
  const cursoIds = Array.isArray(form.curso_ids) ? form.curso_ids : [];

  return (
    <>
      {/* Fila 1: Centro · Codigo · Estado */}
      <div className="row g-3">
        <div className="col-md-4">
          <label className="form-label fw-semibold">Centro</label>
          <div className="d-flex align-items-center gap-2">
            <select
              className="form-select"
              value={form.centro_id || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  centro_id: e.target.value,
                  plantilla_id: "",
                  curso_ids: [],
                }))
              }
              disabled={centrosLoading}
              required
            >
              <option value="">Selecciona un centro</option>
              {renderCentroOptions(centros, centrosLoading)}
            </select>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={reloadCentros}
              title="Recargar centros"
            >
              <i className="bi bi-arrow-repeat" />
            </button>
          </div>
          {centrosError && <div className="text-danger small mt-1">{centrosError}</div>}
        </div>
        <div className="col-md-4">
          <label className="form-label fw-semibold">Codigo</label>
          <input
            type="text"
            className="form-control"
            placeholder="MDI-DRSP"
            value={form.codigo}
            onChange={(e) => setForm((prev) => ({ ...prev, codigo: e.target.value }))}
            required
          />
        </div>
        <div className="col-md-4">
          <label className="form-label fw-semibold">Estado</label>
          <select
            className="form-select"
            value={form.estado}
            onChange={(e) => setForm((prev) => ({ ...prev, estado: e.target.value }))}
          >
            {estadoOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Fila 2: Nombre · Plantilla de convocatoria */}
      <div className="row g-3 mt-0">
        <div className="col-md-6">
          <label className="form-label fw-semibold">Nombre</label>
          <input
            type="text"
            className="form-control"
            placeholder="Ciclo MDI-DRSP 2026"
            value={form.nombre}
            onChange={(e) => setForm((prev) => ({ ...prev, nombre: e.target.value }))}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label fw-semibold">Formato del codigo de convocatoria</label>
          <select
            className="form-select"
            value={form.plantilla_id || ""}
            onChange={(e) => setForm((prev) => ({ ...prev, plantilla_id: e.target.value }))}
            disabled={loadingPlantillas || !form.centro_id}
          >
            <option value="">Sin plantilla</option>
            {loadingPlantillas ? (
              <option disabled>Cargando...</option>
            ) : (
              plantillas.map((p) => (
                <option key={p.id} value={String(p.id)}>
                  {p.nombre}
                </option>
              ))
            )}
          </select>
        </div>
      </div>
      {/* Fila 3: Fechas */}
      <div className="row g-3 mt-0">
        <div className="col-md-6">
          <label className="form-label fw-semibold">Fecha de inicio</label>
          <input
            type="date"
            className="form-control"
            value={form.fecha_inicio || ""}
            onChange={(e) => {
              const val = e.target.value;
              const anio = val ? new Date(val).getFullYear() : "";
              setForm((prev) => ({ ...prev, fecha_inicio: val, anio: String(anio) }));
            }}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label fw-semibold">Fecha de fin</label>
          <input
            type="date"
            className="form-control"
            value={form.fecha_fin || ""}
            onChange={(e) => setForm((prev) => ({ ...prev, fecha_fin: e.target.value }))}
          />
        </div>
      </div>

      <div className="mt-3">
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">Cursos asociados</label>
          {form.centro_id && (
            <button
              type="button"
              className="btn btn-link btn-sm text-decoration-none p-0"
              onClick={reloadCursos}
              disabled={loadingCursos}
            >
              <i className={`bi bi-arrow-repeat me-1${loadingCursos ? " spin" : ""}`} />
              Recargar
            </button>
          )}
        </div>
        <div
          className="border rounded p-2"
          style={{ maxHeight: 220, overflowY: "auto" }}
        >
          {!form.centro_id ? (
            <p className="text-muted small mb-0">Selecciona un centro para ver los cursos disponibles</p>
          ) : loadingCursos ? (
            <p className="text-muted small mb-0">Cargando cursos...</p>
          ) : !cursos.length ? (
            <div className="d-flex align-items-start gap-2 text-warning small">
              <i className="bi bi-exclamation-triangle-fill mt-1 flex-shrink-0" />
              <span>
                Este centro aún no tiene cursos registrados. Para agregar cursos ve a{" "}
                <strong>Coordinación → Cursos → Nuevo curso</strong> y selecciona este centro.
              </span>
            </div>
          ) : (
            <div className="row g-0">
              {cursos.map((curso) => {
                const checked = cursoIds.includes(Number(curso.id));
                return (
                  <div key={curso.id} className="col-md-6">
                    <div
                      className={`d-flex align-items-center gap-2 px-2 py-1 rounded${checked ? " bg-primary bg-opacity-10" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleCurso(form, setForm, curso.id)}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input mt-0 flex-shrink-0"
                        checked={checked}
                        onChange={() => toggleCurso(form, setForm, curso.id)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <span className="small text-truncate">
                        <span className="fw-semibold">{curso.codigo_curso}</span>
                        <span className="text-muted ms-1">{curso.nombre}</span>
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {cursoIds.length > 0 && (
          <div className="form-text">
            {cursoIds.length} curso{cursoIds.length > 1 ? "s" : ""} seleccionado{cursoIds.length > 1 ? "s" : ""}
          </div>
        )}
      </div>

      <div className="mb-3 mt-3">
        <label className="form-label fw-semibold">Observaciones</label>
        <textarea
          className="form-control"
          rows={3}
          placeholder="Notas internas para este ciclo"
          value={form.observaciones}
          onChange={(e) => setForm((prev) => ({ ...prev, observaciones: e.target.value }))}
        />
      </div>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="ciclo-activo"
          checked={form.activo}
          onChange={(e) => setForm((prev) => ({ ...prev, activo: e.target.checked }))}
        />
        <label className="form-check-label" htmlFor="ciclo-activo">
          {form.activo ? "Ciclo activo" : "Ciclo inactivo"}
        </label>
      </div>
    </>
  );
};

export default function CiclosFormModal({
  modal,
  cerrarModal,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  savingNuevo,
  savingEditar,
  deleting,
  detalleLoading,
  cicloSeleccionado,
  centros = [],
  centrosLoading = false,
  centrosError = null,
  reloadCentros = () => {},
  plantillas = [],
  loadingPlantillas = false,
  cursos = [],
  loadingCursos = false,
  reloadCursos = () => {},
  estadoOptions,
  handleCrearCiclo,
  handleActualizarCiclo,
  handleEliminarCiclo,
  canCreate = true,
  canUpdate = true,
  canDelete = true,
}) {
  return (
    <>
      <ModalWrapper open={modal === "nuevo"} title="Registrar ciclo" onClose={cerrarModal} size="modal-xl">
        <form onSubmit={handleCrearCiclo}>
          <div className="modal-body pt-0">
            <FormFields
              form={formNuevo}
              setForm={setFormNuevo}
              estadoOptions={estadoOptions}
              centros={centros}
              centrosLoading={centrosLoading}
              centrosError={centrosError}
              reloadCentros={reloadCentros}
              plantillas={plantillas}
              loadingPlantillas={loadingPlantillas}
              cursos={cursos}
              loadingCursos={loadingCursos}
              reloadCursos={reloadCursos}
            />
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={cerrarModal}
              disabled={savingNuevo}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn management-btn-primary"
              disabled={savingNuevo || !canCreate}
            >
              {savingNuevo ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Guardando...
                </>
              ) : (
                "Guardar"
              )}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "editar" && canUpdate}
        title={`Editar ciclo${cicloSeleccionado ? `: ${cicloSeleccionado.nombre}` : ""}`}
        onClose={cerrarModal}
        size="modal-xl"
      >
        <form onSubmit={handleActualizarCiclo}>
          <div className="modal-body pt-0">
            {detalleLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
              </div>
            ) : (
              <FormFields
                form={formEditar}
                setForm={setFormEditar}
                estadoOptions={estadoOptions}
                centros={centros}
                centrosLoading={centrosLoading}
                centrosError={centrosError}
                reloadCentros={reloadCentros}
                plantillas={plantillas}
                loadingPlantillas={loadingPlantillas}
                cursos={cursos}
                loadingCursos={loadingCursos}
              />
            )}
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={cerrarModal}
              disabled={savingEditar}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn management-btn-primary"
              disabled={savingEditar || detalleLoading || !canUpdate}
            >
              {savingEditar ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Guardando...
                </>
              ) : (
                "Guardar cambios"
              )}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "eliminar" && canDelete}
        title="Eliminar ciclo"
        onClose={cerrarModal}
        size="modal-md"
      >
        <div className="modal-body pt-0">
          <p className="mb-2">
            Estas a punto de eliminar el ciclo{" "}
            <strong>{cicloSeleccionado?.nombre || "seleccionado"}</strong>.
          </p>
          <p className="text-muted mb-0">
            Esta accion desactivara el ciclo y evitara nuevos registros asociados.
          </p>
        </div>
        <div className="modal-footer border-0 pt-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={cerrarModal}
            disabled={deleting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleEliminarCiclo}
            disabled={deleting || !canDelete}
          >
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Eliminando...
              </>
            ) : (
              "Eliminar"
            )}
          </button>
        </div>
      </ModalWrapper>
    </>
  );
}
